import CloseIcon from '@mui/icons-material/Close';
import { Box, Grid, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import PreviewLeft from './PreviewLeft';
import PreviewRight from './PreviewRight';

const WebinarRegistrationPreview = (props) =>
{
	const { handleClose, data } = props;
	const theme = useTheme();
	const downSM = useMediaQuery(theme.breakpoints.down('md'));

	return (
		<>
			<Grid container height='var(--pixel64)' sx={{ background: 'var(--whiteColor)', left: 'var(--font100)' }} top={0} zIndex={9}>
				<Grid item xs={12} p='var(--pixel12)' alignItems={'center'}>
					<Stack direction={'row'} spacing={2} alignItems={'center'} justifyContent={'space-between'}>
						<Box
							component='img'
							src='/images/logos/inLynk_Logo.svg'
							alt='inlynk logo'
							sx={{
								width      : '67.2px',
								height     : 'var(--pixel40)',
								alignItems : 'center'
							}}
						/>
						<Typography variant='h6' onClick={handleClose} style={{ cursor: 'pointer' }}>
							<CloseIcon />
						</Typography>
					</Stack>
				</Grid>
			</Grid>
			<Grid container direction='column' sx={{ backgroundColor: 'var(--baseColor)' }}>
				<Grid container direction={downSM ? 'column' : 'row'} maxWidth={'var(--percent100)'}>
					<Grid item xs={12} sm={5} md={6} lg={8} p={downSM ? 'var(--pixel16)' : 'var(--pixel24)'} sx={{ overflowY: 'auto' }} maxWidth={'100% !important'}>
						<PreviewLeft data={data}/>
					</Grid>
					<Grid item
						xs={12}
						sm={7}
						md={6}
						lg={4}
						p={downSM ? 'var(--pixel16)' : 'var(--pixel24)'}
						sx={{ overflowY: 'auto', minHeight: '100vh' }}
						width={'var(--percent100)'}
					>
						<PreviewRight data={data} />
					</Grid>
				</Grid>
			</Grid>
		</>
	);
};

export default WebinarRegistrationPreview;
